<template>
  <v-dialog
      v-model="display"
      overlay-color="transparent"
      style="z-index: 500 !important;"
      transition="slide"
      width="400">
    <v-sheet
        elevation="3"
        class="block-style pa-4 pb-16 overflow-y-auto"
        height="100vh"
        style="z-index : 99999999999999 !important; "
        :width="!SM ? 400 : '100%'"
    >

      <div class="d-flex justify-space-between align-center mb-5">
        <h4><v-icon :color="wsACCENT" class="mr-2">mdi-pencil</v-icon>{{  $t('EditBlock')  }}</h4>
        <v-btn icon @click="display = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <ws-accordion :items="blockSections">
        <template #item.general>
          <div class="pa-4">
            <h5 class="mb-4">{{ $t('Columns') }}</h5>
            <ws-select
                v-model="block.rows"
                @input="updateBlock"
                :items="columnsSelect"
                outlined dense hide-details
                :placeholder="$t('Columns')"
            />
            <h5 class="mt-8">{{ $t('Background') }}</h5>
            <a-color-picker
                width="100%"
                @input="updateBlock"
                v-model="block.backgroundColor"
                class="mt-2"
                :color-set="$store.state.newsletter.colorSet"
            />

            <a-parameter-slider
                @input="updateBlock"
                v-model="block.borderRadius"
                :label="$t('Rounded')"
                class="mt-4"
                min="0"
                max="300"
            />

          </div>

        </template>
        <template #item.margins>

          <div class="pa-4">
            <h4 class="mb-4">{{ $t('Padding') }}</h4>
            <a-parameter-slider
                @input="updatePaddingX"
                v-model="paddingX"
                :label="$t('Horizontal')"
                icon="mdi-arrow-collapse-horizontal"
                class="mt-4"
                min="0"
                max="100"
            />
            <a-parameter-slider
                @input="updatePaddingY"
                v-model="paddingY"
                :label="$t('Vertical')"
                icon="mdi-arrow-collapse-vertical"
                class="mt-4"
                min="0"
                max="100"
            />
            <h4 class="mb-4">{{ $t('Margin') }}</h4>
            <a-parameter-slider
                v-model="marginX"
                @input="updateMarginX"
                :label="$t('Horizontal')"
                icon="mdi-arrow-split-vertical"
                class="mt-4"
                min="0"
                max="100"
            />
            <a-parameter-slider
                v-model="marginY"
                @input="updateMarginY"
                :label="$t('Vertical')"
                icon="mdi-arrow-split-horizontal"
                class="mt-4"
                min="0"
                max="100"
            />

          </div>


        </template>
      </ws-accordion>


    </v-sheet>
  </v-dialog>

</template>

<script>

export default {
  name: "avalonBlocSettings",
  components : {
  },
  props : {
    value : {
      type : Boolean,
      default : false,
    },
    block : {
      type : Object,
      default() { return {} }
    },
    maxHeight : {
      type : Number,
      default : 0,
    },
    maxHeightSM : {
      type : Number,
      default : 0,
    }
  },
  data() {
    return {
      paddingX : 0,
      paddingY : 0,
      marginX : 0,
      marginY : 0,
      display : false,
      preventClose : false,
      columnsSelect : [
        { text : 1 , value : 1 },
        { text : 2 , value : 2 },
        { text : 3 , value : 3 }
      ]
    }
  },
  computed : {

    blockSections() {
      return [
        { name : this.$t('General') , value : 'general' , icon : 'mdi-cogs', expanded : true },
        { name : this.$t('format.title') , value : 'margins' , icon : 'mdi-arrow-all', expanded : true },
      ]
    },
    backgroundTypes() {
      return [
        { text : this.$t('Color') , value : 'color' , icon : 'mdi-palette'},
        { text : this.$t('Image') , value : 'image' , icon : 'mdi-image'},
        // { text : this.$t('Video') , value : 'video' , icon : 'mdi-video'},
        // { text : this.$t('None')  ,  value : null   , icon : 'mdi-cancel'}
      ]
    }
  },
  watch : {
    value() {
      if ( this.value !== this.display ) {
        this.display = this.value
      }
    },
    display() {
      if ( this.value !== this.display ) {
        this.$emit('input',this.display)
      }
    }
  },
  methods : {
    updatePaddingX(value) {
      this.block.paddingLeft = value
      this.block.paddingRight = value
      this.updateBlock()
    },
    updatePaddingY(value) {
      this.block.paddingTop = value
      this.block.paddingBottom = value
      this.updateBlock()
    },
    updateMarginX(value) {
      this.block.marginLeft = value
      this.block.marginRight = value
      this.updateBlock()
    },
    updateMarginY(value) {
      this.block.marginTop = value
      this.block.marginBottom = value
      this.updateBlock()
    },

    updateImage($event) {
      this.block.config.image = $event.url
      this.updateBlock()
    },
    async updateBlock() {
      this.block = JSON.parse(JSON.stringify(this.block))
      this.$emit('update',this.block)
    }
  },
  mounted() {
    this.display = this.value

    if ( this.block.paddingLeft === this.block.paddingRight ) {
      this.paddingX = this.block.paddingLeft
    }

    if ( this.block.paddingTop === this.block.paddingBottom ) {
      this.paddingY = this.block.paddingTop
    }

    if ( this.block.marginLeft === this.block.marginRight ) {
      this.marginX = this.block.marginLeft
    }

    if ( this.block.marginTop === this.block.marginBottom ) {
      this.marginY = this.block.marginTop
    }

  }
}
</script>

<style scoped>
.block-style {
  position:fixed;
  outline: none;
  top:0;bottom: 0;
  right: 0;
  height: 100% ;
  z-index:1111
}
</style>